import Virtual from '../../utils/virtual'
import { UPDATE_STORE_PARAMS } from '../../config'
import { getRowKeyIter } from '../config/utils'

export default {
  data () {
    return {
      states: {
        mergeCellCacheSize: 3,
        verticalVirtualRange: {
          end: -1,
          padBehind: 0,
          padFront: 0,
          start: 0,
        },
        horizontalVirtualRange: {
          end: 1,
          padBehind: 0,
          padFront: 0,
          start: 0,
        },
        horizontalVirtualConfig: {
          keeps: 1,
          caches: 2,
        },
        dynamicSizeMap: {},
        dynamicSizeList: [],
      }
    }
  },
  computed: {
    // 由于store的代码实在table的data上实现。所以使用不了table的计算属性
    usingDynamicHeight () {
      const { enableDynamicHeight, enableExpandRow } = this.table.$props
      return enableDynamicHeight || enableExpandRow
    },
    viewportRenderColumns () {
      const virtualColumns = this.renderVirtualColumns()
      return virtualColumns
    },
    dynamicRowOffsetYMap () {
      let y = 0
      const { dynamicSizeList } = this.states
      return dynamicSizeList.reduce((map, size, index) => {
        if (index > 0) {
          y += dynamicSizeList[index - 1]
        }
        map[index] = y
        return map
      }, {})
    },
    // 是否使用合并行列配置
    usingRowColMerge () {
      const { spanMethod, mergeEqualCellsOption, mergeCells } = this.table.$props
      return (spanMethod && typeof spanMethod === 'function') || mergeEqualCellsOption || (Array.isArray(mergeCells) && mergeCells.length)
    }
  },
  methods: {
    // 创建水平的虚拟滚动实例 默认开启动态计算（二分法）的逻辑
    // columns是main-table渲染的列配置。为什么是他？ 因为他包含了固定列和非固定列
    createHorizontalVirtual(columns = []) {
      const tableWidth = this.tableWidth
      if (!columns.length || !tableWidth) {
        // 无表头的时候，清空
        this.states.horizontalVirtualConfig.virtualColumns = []
       return
      }
      // 给虚拟列表计算的列应该仅是一级头的配置。因为当存在多级表头的时候以顶层的组件节点作为移动的节点。
      // 子节点会在后续的再次计算后添加进去，因为表格数据真实展示的数据是末级节点
      const { sizes, uniqueIds, virtualColumns } = columns.reduce((acc, col, i) => {
        const { sizes, virtualColumns, uniqueIds } = acc
        const { width, key, level } = col
        if (+level === 1) {
          sizes.set(key, width)
          uniqueIds.push(col.key)
          virtualColumns.push(col)
        }
        return acc
      }, {
        sizes: new Map(), // 虚拟算法计算的每个节点的大小（表头列的宽度在初始化时就能获取）
        virtualColumns: [], // 实际渲染的列（仅一级头，注意一级头需要已知总宽，所以会存在计算的逻辑）
        uniqueIds: [], // 虚拟算法的唯一ID集合
      })
      // 渲染的区间以及预加载的个数
      const { keeps, caches } = this.states.horizontalVirtualConfig

      // 虚拟算法的参数集合
      const virtualParams = {
        keeps: caches + keeps,
        uniqueIds: uniqueIds,
        sizes,
        calcType: 'DYNAMIC' // 直接开启动虚拟算法的态计算逻辑
      }
      this.states.horizontalVirtualConfig.virtualColumns = virtualColumns

      // 当水平方向发生滚动时虚拟算法的执行的回调。更新滚动位置而计算的区间
      const updateHorizontalVirtualRangeCallback = this.updateHorizontalVirtualRangeCallback
      const virtualInstance = new Virtual(virtualParams, function (range) {
        updateHorizontalVirtualRangeCallback(range)
      })
      // 存储水平实例
      this.horizontalVirtual = virtualInstance
      const { scrollLeft } = this.states.scrollPos
      // 在水平距离上计算正确的区间。该方法会执行上面的 updateHorizontalVirtualRangeCallback。 而后更新正确的区间值
      this.horizontalVirtual.handleScroll(scrollLeft)
    },
    // 水平滚动后触发虚拟算法的callback回调，计算正确的渲染区间
    updateHorizontalVirtualRangeCallback (range) {
      const { horizontalVirtualConfig } = this.states
      // 当前可渲染的处理后的列的配置（只含有一级头）
      const { virtualColumns = [] } = horizontalVirtualConfig
      if (this.table.$props.useHorizontalVirtualScroll) {
        // 判断是否存在合并行列。
        if (this.usingRowColMerge) {
          const { mergeColspanMaps } = this.states
          // 存在则需要兜底判断当前渲染的起始区间start是否 是合并列中的成员。 是则需要计算合并列的起始列，修正当前的start
          const { mergeCellStart, mergeIndex } = this.computedMergeCell(range.start, mergeColspanMaps) || {}
          if (mergeCellStart >= 0) {
            const { offsetX } = virtualColumns[mergeCellStart]
            range.start = mergeCellStart
            // 同时修正 padFront。 padFront是用于水平方向的偏移量
            range.padFront = mergeIndex.indexOf(range.start) > -1 ? offsetX : range.padFront
          }
        }

        // 同时，需要兼容特殊的场景，当某个节点列的size太大导致，水平移动过程中出现渲染区间出现区间渲染错误的空白问题
        // 所以需要 再次计算正确渲染的结束区间 他们的size总和必须大于容器的宽度，且在结束位置不等于可渲染长度时，包含补齐区间中等同于最大size的 后续的个数和
        const maxLength = virtualColumns.length
        const tableWidth = this.tableWidth

        // 最大值为渲染的最后索引
        const iter = (i) => {
          const col = virtualColumns[i]
          return col.width || 0
        }
        // 更新正确的渲染个数
        range.end = this.dynamicCalcialateRenderEndIndex({
          maxLength,
          range,
          boundarySize: tableWidth,
          sizeKeys: virtualColumns
        }, iter)
      } else {
        // 非虚拟列表直接展示所有
        range.start = 0
        range.padFront = 0
        range.end = virtualColumns.length - 1
      }

      this.states.horizontalVirtualRange = range
    },
    // 动态计算正确的渲染的个数
    dynamicCalcialateRenderEndIndex ({maxLength, range, boundarySize, sizeKeys}, getSize) {
      // 结束值
      let endIndex = range.end
      // 如果结束值等于最后的索引则不在计算
      if (endIndex === maxLength - 1) {
        return endIndex
      }
      // column中最大的宽度
      let maxSize = 0
      // column中最大的宽度对应的索引
      let maxSizeIndex = -1
      // 起始值的和
      let rangeSize = 0
      // 找到最大值与索引
      for (endIndex = range.start; endIndex < maxLength; endIndex++) {
        const size = getSize(endIndex) || 0

        if (maxSize < size) {
          maxSize = size
          maxSizeIndex = endIndex
        }

        rangeSize += size

        if (rangeSize >= boundarySize + maxSize) {
          break
        }
      }
      // 如果存在最大值，则还需要 使用最大值作为索引，然后计算后续累加的节点的size的和是否大于最大值，并记录个数。追加给endIndex
      if (maxSizeIndex > -1) {
        let sumWidth = 0
        let num = 0
        for (let i = maxSizeIndex + 1; i < sizeKeys.length; i++) {
          sumWidth += getSize(i)
          num++
          if (sumWidth > maxSize) {
            break
          }
        }
        endIndex += num
      }

      // 不能超过数据的最大索引
      return Math.min(endIndex, maxLength - 1)
    },
    // 计算并优化水平可视区域的区间配置（正确渲染的columns） 比如，当前渲染的列配置的size和超过容器的宽度的，则增加仅渲染空标签的标识
    renderVirtualColumns () {
      const { horizontalVirtualRange, mainColumns, horizontalVirtualConfig, scrollPos, mergeColspanMaps = {} } = this.states
      const { virtualColumns = [] } = horizontalVirtualConfig
      const { start, end } = horizontalVirtualRange
      // 由于计算是通过一级头，所以截取也是从一级头，然后把子节点塞进去。为什么，因为父节点不能被动态。不允许出现抖动的动画
      const cols = virtualColumns.slice(start, end + 1)
      const renderColumns = cols.reduce((acc, col) => {
        const { childKeys } = col
        acc.push(col)
        if (childKeys && childKeys.length) {
          // 折叠的状态已经在 mainColumns处理过滤后了
          const childNodes = mainColumns.reduce((arr, mainCol) => {
            if (childKeys.indexOf(mainCol.key) > -1 && acc.map(c => c.key).indexOf(mainCol.key) === -1) {
              arr.push(mainCol)
            }
            return arr
          }, [])
          acc.push(...childNodes)
        }
        return acc
      }, [])

      if (!this.table.$props.useHorizontalVirtualScroll) {
        return renderColumns
      }
      const tableWidth = this.tableWidth
      const { scrollLeft } = scrollPos

      // 合并列的集合。
      const mergeCells = Object.values(mergeColspanMaps).map(c => c.mergeIndex).flat()

      for (let i = 0; i < renderColumns.length; i++) {
        const col = renderColumns[i]
        const { offsetX, width, originIndex } = col

        // 有合并行的 还需要算上合并行的. 合并行列不做处理。展示本身的状态，比如合并列的配置
        if (mergeCells.length && mergeCells.indexOf(originIndex) > -1) {
          col.placeholderSign = false
          continue
        }

        // 仅渲染可视区域的内容，否则用 placeholderSign做为表示 渲染空标签 // placeholderSign: true
        if (offsetX > 0 && (offsetX + width < scrollLeft || (tableWidth + scrollLeft - offsetX) < 0)) {
          col.placeholderSign = true
        } else {
          col.placeholderSign = !!col.fixed
        }
      }
      return renderColumns
    },
    // 创建纵向虚拟滚动的实例
    createVerticalVirtual({ tableData, cacheSize = 0, rowKey }) {
      const preDynamicSizeMap = JSON.parse(JSON.stringify(this.states.dynamicSizeMap))
      // 每次创建都需要清空收集的动态行高的集合，不能直接清空，如果之前存在的话，则去之间的
      this.states.dynamicSizeMap = {}
      this.states.dynamicSizeList = []
      // 同样，计算合并行的场景
      if (this.usingRowColMerge) {
        cacheSize += this.states.mergeCellCacheSize
      }
      // 预估高度 行高
      const { estimatedRowHeight, rowHeight } = this.states
      // 一屏所需要展示的个数 初始计算的个数在动态行高时，需要重新计算正确的个数。在虚拟算法执行回调之后
      const _kepps = Math.floor((this.tableBodyHeight / rowHeight))
      const { uniqueIds, sizes } = tableData.reduce((config, row) => {
        const id = String(getRowKeyIter(row, rowKey))
        const preDynamicSize = preDynamicSizeMap[id]
        config.sizes.set(id, preDynamicSize || estimatedRowHeight) // 首次执行使用用户传递的预估高度
        config.uniqueIds.push(id) // 唯一值
        return config
      }, {
        sizes: new Map(),
        uniqueIds: []
      })
      let virtualParams = {
        fixedSizeValue: rowHeight,
        keeps: _kepps + cacheSize || 0, // 需要渲染的个数
        estimateSize: rowHeight,
        uniqueIds,
      }
      // 开启动态行高时的配置
      if (this.usingDynamicHeight) {
        virtualParams = Object.assign({}, virtualParams, {
          sizes,
          calcType: 'DYNAMIC',
          keeps: 2,
          fixedSizeValue: estimatedRowHeight,
          estimateSize: estimatedRowHeight,
        })
      }
      const updateVerticalVirtualRangeCallback = this.updateVerticalVirtualRangeCallback
      const verticalVirtualInstance = new Virtual(virtualParams, function (range) {
        updateVerticalVirtualRangeCallback(range, this)
      })
      this.virtualInstance = verticalVirtualInstance
      // 默认的预估高度配置（数组形式），用于优化纵向渲染节点
      this.states.dynamicSizeList = uniqueIds.map(_id => sizes.get(_id) || estimatedRowHeight)
      // 默认动态配置，用于计算真实的实际渲染节点的行高总和 以及虚拟算法计算的源数据。
      this.$set(this.states, 'dynamicSizeMap', Object.fromEntries(sizes))
    },
    // 纵向虚拟滚动事件触发回调。
    updateVerticalVirtualRangeCallback(range, verticalInstance) {
      // 关于合并列的处理
      if (this.usingRowColMerge) {
        const { mergeRowspanMaps } = this.states
        const { mergeCellStart } = this.computedMergeCell(range.start, mergeRowspanMaps) || {}
        // 与水平方向一致，判断起始区间是否包含在合并列中，重新计算起始值。
        if (mergeCellStart >= 0) {
          range.start = mergeCellStart
          range.padFront = mergeCellStart * this.states.rowHeight
        }
        // 判断结束区间是否包含合并列中，重新计算起始值。
        const extraLengthInEndMergeCell = this.computedRangeEndInMergedCell(range.end, mergeRowspanMaps)
        if (extraLengthInEndMergeCell) {
          range.end += extraLengthInEndMergeCell
        }
      }
      // 开启动态行高时，重新计算渲染区间个数。同水平方向一致。 TODO 方法抽离
      if (this.usingDynamicHeight) {
        // 动态计算渲染的个数 必须大于容器的宽度
        const sizes = verticalInstance.sizes
        const sizeKeys = Array.from(sizes.keys())
        const maxLength = sizeKeys.length
        const tableHeight = this.tableBodyHeight

        // 最大值为渲染的最后索引
        const iter = (i) => {
          const uniqueId = sizeKeys[i]
          const size = sizes.get(uniqueId) || 0
          return size
        }
        range.end = this.dynamicCalcialateRenderEndIndex({
          maxLength,
          range,
          boundarySize: tableHeight,
          sizeKeys
        }, iter)
      }
      this.commit(UPDATE_STORE_PARAMS, {
        verticalVirtualRange: range
      })
      // 数据更新
      // TODO 优化，判断回调值是否相同再执行？
      this.updateTableRenderData()
    },
    // 纵向时，存储动态行高的size
    setVerticalVirtualSizeMap (id, size, rowIndex, isMainTable) {
      id = String(id)
      if (!id) {
        return
      }
      const virtualInstance = this.virtualInstance
      const { estimatedRowHeight } = this.states
      // 不存在的删除掉，防止数据有误
      if (!virtualInstance.sizes.has(id)) {
        virtualInstance.sizes.delete(id)
        return
      }
      const preSize = virtualInstance.sizes.get(id)

      // TODO 增加过渡的开关，测试无问题后去掉
      if (this.table.$props.dynamicRowSize) {
        // 小于预估高度，则等于预估高度
        if (size < estimatedRowHeight) {
          size = estimatedRowHeight
        }
        // 非主列表则需对比最大的值
        if (!isMainTable) {
          size = Math.max(...[preSize, size])
        }
        this.$set(this.states.dynamicSizeMap, id, size)
        this.$set(this.states.dynamicSizeList, rowIndex, size)
        virtualInstance.saveSize(id, size)
        return
      }
      // 如果上次size小于当前 或者 size小于预估，则存储并交给虚拟算法计算。
      // 好处，防止页面抖动。缺点。自动分配时，高度只增不减。 TODO 策略优化
      if (preSize < size || size < estimatedRowHeight) {
        this.$set(this.states.dynamicSizeMap, id, size)
        this.$set(this.states.dynamicSizeList, rowIndex, size)
        virtualInstance.saveSize(id, size)
      }
    },
    // 开启动态行高时，获取实际渲染的总高度。其中，未获取时，使用预估高度。
    getEstimatedTotalHeight () {
      const { tableDataLength, estimatedRowHeight, dynamicSizeMap } = this.states
      // TODO 判断多余了。未设置默认值时，需要判断。现在不需要了。
      const keys = Object.keys(dynamicSizeMap)
      let visitedLength = keys.length
      let sizeOfVisitedRows = 0
      if (visitedLength >= tableDataLength) {
        visitedLength = tableDataLength
      }
      if (visitedLength > 0) {
        const uniqueIds = this.virtualInstance ? this.virtualInstance.param.uniqueIds : []
        sizeOfVisitedRows = keys.reduce((acc, id) => {
          if (uniqueIds.length) {
            if (uniqueIds.indexOf(id) > -1) {
              acc += dynamicSizeMap[id]
            }
          } else {
            acc += dynamicSizeMap[id]
          }
          return acc
        }, 0)
      }
      const unvisitedItems = tableDataLength - visitedLength
      const sizeOfUnvisitedItems = unvisitedItems * estimatedRowHeight
      const acc = sizeOfVisitedRows + sizeOfUnvisitedItems
      return acc
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/store/modules/virtual.js